package nl.appstuff.padelchecker.site.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import nl.appstuff.padelchecker.site.localization.LocalSiteStrings
import org.jetbrains.compose.web.css.*

@Composable
fun UpcomingSection() {
    val isDesktop = rememberBreakpoint() >= Breakpoint.MD
    val strings = LocalSiteStrings.current

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.rgb(0xE8F0FE))
            .padding(topBottom = if (isDesktop) 50.px else 20.px, leftRight = 24.px),
        contentAlignment = Alignment.Center,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(1120.px),
            horizontalArrangement = Arrangement.spacedBy(if (isDesktop) 32.px else 16.px),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Image(
                src = "/images/padelprikker.png",
                alt = strings.upcomingImageAlt,
                modifier = Modifier.width(if (isDesktop) 116.px else 70.px),
            )
            UpcomingText(Modifier.flex(1))
        }
    }
}

@Composable
private fun UpcomingText(modifier: Modifier = Modifier) {
    val isDesktop = rememberBreakpoint() >= Breakpoint.MD
    val strings = LocalSiteStrings.current

    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(if (isDesktop) 12.px else 10.px)) {
        SpanText(
            strings.upcomingBadge,
            modifier = Modifier
                .background(Color.rgb(0x34A853))
                .borderRadius(999.px)
                .padding(leftRight = if (isDesktop) 12.px else 10.px, topBottom = 4.px)
                .fontSize(if (isDesktop) 16.px else 13.px)
                .fontWeight(FontWeight.SemiBold)
                .color(Color.rgb(0xFFFFFF)),
        )

        Column(verticalArrangement = Arrangement.spacedBy(4.px)) {
            SpanText(
                strings.upcomingTitleLine1,
                modifier = Modifier
                    .fontSize(if (isDesktop) 34.px else 24.px)
                    .lineHeight(1.06)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Color.rgb(0x111111)),
            )
            Row(
                horizontalArrangement = Arrangement.spacedBy(if (isDesktop) 12.px else 8.px),
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
            ) {
                SpanText(
                    strings.upcomingPlanningWith,
                    modifier = Modifier
                        .fontSize(if (isDesktop) 34.px else 24.px)
                        .lineHeight(1.06)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Color.rgb(0x111111)),
                )
                SpanText(
                    strings.upcomingPadelPollChip,
                    modifier = Modifier
                        .padding(leftRight = if (isDesktop) 16.px else 10.px, topBottom = 2.px)
                        .background(Color.rgb(0xFFFFFF))
                        .border(2.px, LineStyle.Solid, Color.rgb(0x1A73E8))
                        .borderRadius(999.px)
                        .fontSize(if (isDesktop) 34.px else 24.px)
                        .lineHeight(1.06)
                        .fontWeight(FontWeight.SemiBold)
                        .color(Color.rgb(0x1A73E8)),
                )
            }
        }

        SpanText(
            strings.upcomingBody,
            modifier = Modifier
                .maxWidth(560.px)
                .fontSize(if (isDesktop) 16.px else 14.px)
                .lineHeight(1.45)
                .color(Color.rgb(0x3C4043)),
        )
    }
}
